import _ from 'underscore';
import BaseView from 'picnic/core/views/Base';
import CheckAllLink from 'app/cms/carpricechecker/views/appointmentsSelect/CheckAllLink';
import Filter from 'app/cms/carpricechecker/views/appointmentsSelect/Filter';


const
	RESET_FILTER_TEXT = 'Filter zurücksetzen'
;


class View extends BaseView {

	constructor(options) {
		super(options);

		_.bindAll(
			this,
			'_onToggleAll',
			'_onChange'
		);
	}

	get checkedOptions() {
		return this._inputViews.filter(input => input.isChecked).map(view => view.value);
	}

	get isAllChecked() {
		var
			checkedCount = this._inputViews.filter(input => input.isChecked === true)
		;

		return checkedCount.length === this._inputViews.length;
	}

	render() {
		super.render();

		this._renderInputs();
		this._renderCheckAllLink();

		return this;
	}

	toggleCheckAll(state) {
		this._inputViews.forEach(input => input.toggleCheck(state));
		this._checkAllLink.toggleText(state ? RESET_FILTER_TEXT : undefined);
	}

	_renderInputs() {
		var
			views = []
		;

		[...this.el.getElementsByTagName('input')].forEach(input => {
			var view = new Filter({
				el: input,
				context: this.context
			}).render();

			view.on('change', this._onChange);

			views.push(view);
		});

		this._inputViews = views;
	}

	_renderCheckAllLink() {
		var view = new CheckAllLink({
			el: this.el,
			context: this.context
		}).render();

		view.on('click', this._onToggleAll);

		this._checkAllLink = view;
	}

	_onChange() {
		this._checkAllLink.toggleText(this.isAllChecked ? RESET_FILTER_TEXT : undefined);

		this.trigger('toggle', {
			instance: this
		});
	}

	_onToggleAll() {
		var
			checkedCount = this._inputViews.filter(input => input.isChecked)
		;

		this.toggleCheckAll(checkedCount.length < this._inputViews.length);

		this.trigger('toggle', {
			instance: this
		});
	}

}

export default View;
